// `/app/settings/rates` (`spec/17-frontend.md` §8.1, `spec/tasks/WEB-61.md`). Leitura
// pura, sem step-up.
//
// A versão agendada abre em drawer com URL (`?version=<id>`), não em rota `$id`: mesma
// razão da WEB-53 (`files_allowed` sem arquivo de rota novo).

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useMode } from '../app/mode.tsx';
import { RatesScreen } from '../features/account/rates-screen.tsx';

const searchSchema = z.object({
  version: z.string().min(1).optional().catch(undefined),
});

function Rates() {
  const { version } = Route.useSearch();
  const navigate = useNavigate();
  const { mode } = useMode();

  const go = (next: string | undefined): void => {
    void navigate({
      to: '/app/settings/rates',
      search: next === undefined ? {} : { version: next },
    });
  };

  return (
    <RatesScreen
      mode={mode}
      versionId={version}
      onOpenVersion={go}
      onCloseVersion={() => {
        go(undefined);
      }}
      onOpenDocs={() => {
        void navigate({ to: '/app/developers/docs' });
      }}
    />
  );
}

export const Route = createFileRoute('/app/settings/rates/')({
  validateSearch: searchSchema,
  component: Rates,
});
